document.addEventListener("DOMContentLoaded", function() {
  var popup = document.getElementById("popup-crosssell");
  var overlay = document.getElementById("overlay-crosssell");
  var fermer = document.getElementById("fermer-popup");
  var noThanks = document.getElementById("no-thanks");
  var prixTotal = document.querySelector(".prix-total");
  var conteneurProduits = document.getElementById("produits-suggeres");

  function fermerPopup() {
    popup.style.display = "none";
    overlay.style.display = "none";
  }

  if (fermer) fermer.addEventListener("click", fermerPopup);
  if (noThanks) noThanks.addEventListener("click", fermerPopup);
  if (overlay) overlay.addEventListener("click", fermerPopup);

  var originalFetch = window.fetch;
  window.fetch = function() {
    var args = Array.prototype.slice.call(arguments);
    var url = args[0];
    if (typeof url === "string" && url.includes("/cart/add")) {
      return originalFetch.apply(this, args).then(function(response) {
        response.clone().json().then(function(data) {
          var productId = data.product_id;

          var triggerImg = document.getElementById("trigger-img");
          var triggerNom = document.getElementById("trigger-nom");
          var triggerPrix = document.getElementById("trigger-prix");
          if (triggerImg && data.image) {
            var src = data.image;
            if (src.indexOf("//") === 0) src = "https:" + src;
            triggerImg.src = src.split("?")[0] + "?width=160";
          }
          if (triggerNom) triggerNom.textContent = data.product_title;
          if (triggerPrix) triggerPrix.textContent = (data.price / 100).toFixed(2).replace(".", ",") + "€";

          if (productId) {
            fetch("/recommendations/products.json?product_id=" + productId + "&limit=2")
              .then(function(res) { return res.json(); })
              .then(function(result) {
                var produits = result.products;
                conteneurProduits.innerHTML = "";
                var prixBase = data.price / 100;

                produits.forEach(function(produit) {
                  var prix = produit.price / 100;
                  prixBase += prix;

                  var imgSrc = "https://placehold.co/80x80";
                  var images = produit.images;
                  if (images && images.length > 0) {
                    var src = typeof images[0] === "string" ? images[0] : images[0].src;
                    if (src && src.indexOf("//") === 0) src = "https:" + src;
                    if (src) imgSrc = src.split("?")[0] + "?width=160";
                  } else if (produit.featured_image && produit.featured_image.src) {
                    var src = produit.featured_image.src;
                    if (src.indexOf("//") === 0) src = "https:" + src;
                    imgSrc = src.split("?")[0] + "?width=160";
                  }

                  var ligne = document.createElement("div");
                  ligne.classList.add("produit-ligne");
                  ligne.innerHTML =
                    '<input type="checkbox" class="checkbox-produit" checked data-prix="' + prix + '" data-variant-id="' + produit.variants[0].id + '">' +
                    '<a href="/products/' + produit.handle + '" target="_blank">' +
                      '<img src="' + imgSrc + '" alt="' + produit.title + '">' +
                    '</a>' +
                    '<div>' +
                      '<a href="/products/' + produit.handle + '" target="_blank" style="text-decoration:none; color:inherit;">' +
                        '<p class="nom-produit">' + produit.title + '</p>' +
                      '</a>' +
                      '<p class="prix-popup">' + prix.toFixed(2).replace(".", ",") + '€</p>' +
                      (produit.variants.length > 1 ?
                        '<select>' +
                          produit.variants.map(function(v) {
                            return '<option value="' + v.id + '">' + v.title + '</option>';
                          }).join("") +
                        '</select>'
                      : '') +
                    '</div>';
                  conteneurProduits.appendChild(ligne);
                });

                function calculerTotal() {
                  var total = prixBase;
                  document.querySelectorAll(".checkbox-produit").forEach(function(cb) {
                    if (!cb.checked) total -= parseFloat(cb.dataset.prix);
                  });
                  prixTotal.textContent = total.toFixed(2).replace(".", ",") + "€";
                }

                calculerTotal();

                document.querySelectorAll(".checkbox-produit").forEach(function(cb) {
                  cb.addEventListener("change", calculerTotal);
                });

                var btnAddToCart = document.getElementById("btn-add-to-cart");
                if (btnAddToCart) {
                  btnAddToCart.onclick = function() {
                    var items = [];
                    document.querySelectorAll(".checkbox-produit").forEach(function(cb) {
                      if (cb.checked) {
                        var ligne = cb.closest(".produit-ligne");
                        var select = ligne.querySelector("select");
                        var variantId = select ? parseInt(select.value) : parseInt(cb.dataset.variantId);
                        if (variantId) {
                          items.push({ id: variantId, quantity: 1 });
                        }
                      }
                    });
                    if (items.length > 0) {
                      fetch("/cart/update.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ note: "Popup cross-sell ✨" })
                      }).then(function() {
                        fetch("/cart/add.js", {
                          method: "POST",
                          headers: { "Content-Type": "application/json" },
                          body: JSON.stringify({ items: items })
                        }).then(function() {
                          fermerPopup();
                          window.location.href = "/cart";
                        });
                      });
                    } else {
                      fermerPopup();
                    }
                  };
                }

                popup.style.display = "block";
                overlay.style.display = "block";
              });
          }
        });
        return response;
      });
    }
    return originalFetch.apply(this, args);
  };
});